/* ==========================================================
   NAO CART DRAWER — FINAL CLUB / COUNTRY UPSSELL SCALABLE
   - Auto-open after add to cart
   - Auto-refresh badge / drawer / upsells
   - Wallpaper gift banner + preview card
   - Verre trempé upsell
   - 2e coque -50% progress bar
   - Robust family detection for countries + clubs
   - Works with PSG / OM / RC Lens / Lille / Lyon / France / Portugal etc.
   - Opposite version prioritized, then all same-family products
   - Debut compatible
   ========================================================== */
(() => {
  'use strict';

  if (window.__NAO_CART_DRAWER_CLUB_SCALABLE_FINAL__) return;
  window.__NAO_CART_DRAWER_CLUB_SCALABLE_FINAL__ = true;

  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  const CONFIG = {
    eligibleKeyword: String(drawer.dataset.eligibleKeyword || 'coque').toLowerCase(),
    promoQty: parseInt(drawer.dataset.promoQty || '2', 10),
    glassHandle: 'verre-trempe-de-protection',
    addOpenDelay: 280,
    refreshDelay: 120,
    fallbackSubmitDelay: 700,
    pairingImageWidth: 520,
    wallpaperPreviewWidth: 180,
    cartItemImageWidth: 420,
    glassImageWidth: 180,
    maxReco: 6,
    searchLimit: 24
  };

  const els = {
    items: drawer.querySelector('#cd-items'),
    total: drawer.querySelector('#cd-total'),
    count: drawer.querySelector('#cd-count'),
    progressText: drawer.querySelector('#cd-progress-text'),
    progressBar: drawer.querySelector('#cd-progress-bar'),
    ctaTotal: drawer.querySelector('#cd-cta-total'),
    glassSection: drawer.querySelector('#cd-glass'),
    glassSwitch: drawer.querySelector('#cd-glass-switch'),
    glassImg: drawer.querySelector('#cd-glass-img')
  };

  const moneyFmt = (window.Shopify && Shopify.money_format) ? Shopify.money_format : null;

  const TYPE_WORDS = [
    'domicile', 'exterieur', 'extérieur', 'away', 'home',
    'third', 'fourth', 'gardien', 'goalkeeper',
    'training', 'prematch', 'pre-match', 'vintage', 'concept',
    'jordan', 'night'
  ];

  const NOISE_WORDS = [
    'coque', 'football', 'smartphone', 'telephone', 'téléphone', 'phone',
    'personnalisee', 'personnalisée', 'personnalise', 'personnalisé',
    'nom', 'numero', 'numéro', '2eme', '2ème', '50', 'case', 'cover',
    'iphone', 'samsung', 'xiaomi', 'redmi'
  ];

  const KEEP_SHORT_WORDS = ['psg', 'om', 'ol', 'rc', 'losc', 'asm'];

  const money = (cents) => {
    const c = Number(cents || 0);
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && moneyFmt) {
      return Shopify.formatMoney(c, moneyFmt);
    }
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    }).format(c / 100);
  };

  const norm = (s) => {
    try {
      return (s || '')
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim();
    } catch (e) {
      return (s || '').toString().toLowerCase().trim();
    }
  };

  const esc = (s) => (s || '').toString().replace(/[&<>"']/g, (m) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
  }[m]));

  function cleanTitle(title) {
    let t = (title || '').toString();

    t = t.replace(/coque football\s*/gi, '');
    t = t.replace(/coque smartphone\s*/gi, '');
    t = t.replace(/coque telephone\s*/gi, '');
    t = t.replace(/coque téléphone\s*/gi, '');
    t = t.replace(/coque de telephone\s*/gi, '');
    t = t.replace(/coque de téléphone\s*/gi, '');
    t = t.replace(/coque\s*/gi, '');

    t = t.replace(/personnalis[ée]?\s*nom\s*num[ée]ro/gi, '');
    t = t.replace(/personnalis[ée]?/gi, '');

    t = t.replace(/\s*[-–—]?\s*2[èe]me\s*coque\s*-?50%/gi, '');
    t = t.replace(/\s*[-–—]?\s*iPhone\s*Samsung\s*Xiaomi\s*Redmi/gi, '');

    t = t.replace(/— —/g, '');
    t = t.replace(/– –/g, '');
    t = t.replace(/--/g, '');
    t = t.replace(/\s[-–—]\s/g, ' ');
    t = t.replace(/\s{2,}/g, ' ').trim();

    return t;
  }

  function upscaleShopifyImage(url, width = 420) {
    if (!url) return '';
    let out = String(url);

    if (out.startsWith('//')) out = window.location.protocol + out;
    if (!/^https?:\/\//i.test(out)) return out;

    if (/cdn\.shopify\.com/i.test(out)) {
      if (out.includes('?')) {
        if (/[\?&]width=/.test(out)) {
          out = out.replace(/([?&]width=)\d+/i, `$1${width}`);
        } else {
          out += `&width=${width}`;
        }
      } else {
        out += `?width=${width}`;
      }
    }

    return out;
  }

  function getHandleFromUrl(url) {
    const m = String(url || '').match(/\/products\/([^/?#]+)/i);
    return m ? m[1] : '';
  }

  function getProductHandle(item) {
    if (!item) return '';
    if (item.handle) return norm(item.handle);
    return norm(getHandleFromUrl(item.url || ''));
  }

  function detectType(text) {
    const t = norm(text);
    if (t.includes('domicile')) return 'domicile';
    if (t.includes('exterieur') || t.includes('extérieur')) return 'exterieur';
    if (t.includes('third')) return 'third';
    if (t.includes('fourth')) return 'fourth';
    if (t.includes('gardien') || t.includes('goalkeeper')) return 'gardien';
    if (t.includes('training')) return 'training';
    if (t.includes('prematch') || t.includes('pre-match')) return 'prematch';
    if (t.includes('vintage')) return 'vintage';
    if (t.includes('concept')) return 'concept';
    if (t.includes('jordan')) return 'jordan';
    return '';
  }

  function getOppositeType(type) {
    if (type === 'domicile') return 'exterieur';
    if (type === 'exterieur') return 'domicile';
    return '';
  }

  function prettifyType(type) {
    if (type === 'domicile') return 'Domicile';
    if (type === 'exterieur') return 'Extérieur';
    if (type === 'third') return 'Third';
    if (type === 'fourth') return 'Fourth';
    if (type === 'gardien') return 'Gardien';
    if (type === 'training') return 'Training';
    if (type === 'prematch') return 'Prematch';
    if (type === 'vintage') return 'Vintage';
    if (type === 'concept') return 'Concept';
    if (type === 'jordan') return 'Jordan';
    return '';
  }

  function splitWords(text) {
    return norm(text)
      .replace(/[\/|–—-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .split(' ')
      .filter(Boolean);
  }

  function isYearWord(word) {
    return /^(20\d{2}|\d{4}|\d{2}\/\d{2})$/.test(word);
  }

  function extractFamilyFromTitle(title) {
    const cleaned = cleanTitle(title || '');
    const words = splitWords(cleaned);
    const family = [];

    for (const w of words) {
      if (!w) continue;
      if (isYearWord(w)) break;
      if (TYPE_WORDS.includes(w)) break;
      if (NOISE_WORDS.includes(w)) continue;
      family.push(w);
    }

    return family.join(' ').trim();
  }

  function extractFamilyFromHandle(handle) {
    const words = splitWords(String(handle || '').replace(/^coque-/, ''));
    const family = [];

    for (const w of words) {
      if (!w) continue;
      if (isYearWord(w)) continue;
      if (TYPE_WORDS.includes(w)) continue;
      if (NOISE_WORDS.includes(w)) continue;
      family.push(w);
    }

    return family.join(' ').trim();
  }

  function getFamilyLabel(itemOrProduct) {
    const title = itemOrProduct ? (itemOrProduct.product_title || itemOrProduct.title || '') : '';
    const handle = itemOrProduct ? (itemOrProduct.handle || getHandleFromUrl(itemOrProduct.url || '')) : '';

    const fromTitle = extractFamilyFromTitle(title);
    const fromHandle = extractFamilyFromHandle(handle);

    if (fromTitle && fromTitle.length >= 2) return fromTitle;
    if (fromHandle && fromHandle.length >= 2) return fromHandle;
    return fromTitle || fromHandle || '';
  }

  function familyWords(label) {
    return splitWords(label).filter((w) => {
      if (KEEP_SHORT_WORDS.includes(w)) return true;
      return w.length >= 2;
    });
  }

  function familyMatches(product, baseFamilyLabel) {
    const baseWords = familyWords(baseFamilyLabel);
    if (!baseWords.length) return false;

    const productTitle = norm(product.title || '');
    const productHandle = norm(product.handle || getHandleFromUrl(product.url || ''));

    const haystack = `${productTitle} ${productHandle}`;

    let matched = 0;
    for (const w of baseWords) {
      if (haystack.includes(w)) matched += 1;
    }

    if (baseWords.length === 1) return matched === 1;
    return matched >= Math.min(2, baseWords.length);
  }

  function buildSearchQueries(baseItem) {
    const title = cleanTitle(baseItem.product_title || baseItem.title || '');
    const handle = getProductHandle(baseItem);
    const family = getFamilyLabel(baseItem);
    const queries = new Set();

    if (family) {
      queries.add(`${family} coque`);
      queries.add(family);
    }

    const titleFamily = extractFamilyFromTitle(title);
    if (titleFamily) {
      queries.add(`${titleFamily} coque`);
      queries.add(titleFamily);
    }

    const handleFamily = extractFamilyFromHandle(handle);
    if (handleFamily) {
      queries.add(`${handleFamily} coque`);
      queries.add(handleFamily);
    }

    if (title) queries.add(title);

    return Array.from(queries).filter(Boolean);
  }

  function updateCartBubbleCount(cart) {
    const count = Number(cart && cart.item_count ? cart.item_count : 0);

    [
      '#cart-icon-bubble .count-bubble',
      '.site-header__cart-count',
      '.cart-count',
      '[data-cart-count]'
    ].forEach((sel) => {
      document.querySelectorAll(sel).forEach((node) => {
        node.textContent = count;
        if (count > 0) {
          node.style.display = '';
          node.classList.remove('hide', 'hidden');
        } else {
          node.style.display = 'none';
        }
      });
    });

    const bubble = document.querySelector('#cart-icon-bubble');
    if (bubble) {
      bubble.setAttribute('data-cart-count', String(count));
      bubble.classList.toggle('has-count', count > 0);
    }
  }

  function buildPrefillParams(item) {
    const params = new URLSearchParams();
    const props = item && item.properties ? item.properties : {};

    Object.keys(props).forEach((key) => {
      const val = props[key];
      if (!key) return;
      if (String(key).charAt(0) === '_') return;
      if (val == null || String(val).trim() === '') return;
      if (typeof val === 'string' && /^https?:\/\//i.test(val)) return;
      params.append(key, String(val));
    });

    params.append('nao_offer', 'second-coque-50');
    params.append('source', 'cart-drawer-upsell');

    return params.toString();
  }

  function getWallpaperData(item) {
    const props = item && item.properties ? item.properties : {};
    const truthy = ['1', 'true', 'yes', 'oui', 'offert', 'included', 'inclu'];

    const info = {
      active: false,
      url: '',
      preview: '',
      title: ''
    };

    for (const rawKey in props) {
      if (!Object.prototype.hasOwnProperty.call(props, rawKey)) continue;

      const rawVal = props[rawKey];
      const key = norm(rawKey);
      const val = (rawVal == null ? '' : String(rawVal)).trim();
      const valNorm = norm(val);

      if (!val) continue;

      const isWallpaperKey =
        key.includes('wallpaper') ||
        key.includes('fond d ecran') ||
        key.includes('fond d’écran') ||
        key.includes('fond-ecran') ||
        key.includes('fond_ecran');

      if (!isWallpaperKey) continue;

      if ((key.includes('_wallpaper_preview') || key.includes('preview') || key.includes('apercu')) && /^https?:\/\//i.test(val)) {
        info.active = true;
        info.preview = val;
        continue;
      }

      if ((key.includes('_wallpaper_url') || key.includes('url')) && /^https?:\/\//i.test(val)) {
        info.active = true;
        info.url = val;
        continue;
      }

      if (key.includes('title') || key.includes('titre')) {
        info.active = true;
        if (!info.title) info.title = val;
        continue;
      }

      if (/^https?:\/\//i.test(val)) {
        info.active = true;
        if (!info.url) info.url = val;
        continue;
      }

      if (truthy.includes(valNorm)) {
        info.active = true;
        continue;
      }

      if (!info.title) {
        info.active = true;
        info.title = val;
      }
    }

    return info;
  }

  function hasWallpaper(item) {
    return getWallpaperData(item).active === true;
  }

  function renderWallpaperCard(item) {
    const wallpaper = getWallpaperData(item);
    if (!wallpaper.active) return '';

    const previewSrc = wallpaper.preview || wallpaper.url || '';
    const previewHTML = previewSrc
      ? `
        <div class="cd-wallpaper__preview">
          <img src="${esc(upscaleShopifyImage(previewSrc, CONFIG.wallpaperPreviewWidth))}" alt="Fond d’écran offert" loading="lazy">
        </div>
      `
      : '';

    return `
      <div class="cd-wallpaper">
        ${previewHTML}
        <div class="cd-wallpaper__content">
          <div class="cd-wallpaper__title">Fond d’écran offert</div>
          <div class="cd-wallpaper__sub">Assorti à ta coque</div>
        </div>
        <div class="cd-wallpaper__badge">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path fill="currentColor" d="M12 2l2.39 4.84L20 7.64l-4 3.9.94 5.46L12 14.77 7.06 17l.94-5.46-4-3.9 5.61-.8L12 2z"></path>
          </svg>
          Offert
        </div>
      </div>
    `;
  }

  function renderWallpaperGlobal(cart) {
    const hasAnyWallpaper = (cart.items || []).some((item) => hasWallpaper(item));
    if (!hasAnyWallpaper) return '';

    return `
      <div class="cd-wallpaper-global">
        🎁 Un fond d’écran exclusif est offert avec ta commande
      </div>
    `;
  }

  let lastActive = null;
  const focusableSel = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

  const open = () => {
    lastActive = document.activeElement || null;
    drawer.classList.remove('hidden');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.removeAttribute('inert');
    document.body.classList.add('drawer-open');

    const f = drawer.querySelector(focusableSel);
    if (f) setTimeout(() => f.focus(), 0);

    fetchCart();
  };

  const close = () => {
    if (drawer.contains(document.activeElement)) {
      try { document.activeElement.blur(); } catch (e) {}
    }

    drawer.classList.add('hidden');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    document.body.classList.remove('drawer-open');

    if (lastActive && document.contains(lastActive)) {
      try { lastActive.focus(); } catch (e) {}
    }
  };

  drawer.addEventListener('click', (e) => {
    if (e.target.matches('[data-close]') || e.target.closest('[data-close]')) close();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });

  function bindCartTriggers(scope = document) {
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble && !bubble.hasAttribute('data-open-cart')) bubble.setAttribute('data-open-cart', '');

    scope.querySelectorAll('[data-open-cart], a[href="/cart"], a[href^="/cart?"], .site-header__cart, .header__icon--cart, .cart-link')
      .forEach((el) => {
        if (el.__nao_bound__) return;
        el.__nao_bound__ = true;

        el.addEventListener('click', (ev) => {
          if (el.tagName === 'A') ev.preventDefault();
          ev.stopPropagation();
          open();
        }, { passive: false });
      });
  }

  bindCartTriggers();
  document.addEventListener('shopify:section:load', (ev) => bindCartTriggers(ev.target));
  document.addEventListener('shopify:section:select', (ev) => bindCartTriggers(ev.target));

  function getPreviewImage(item) {
    const props = item.properties || {};
    const urlRe = /^https?:\/\//i;
    const keysPriority = ['pplr', 'preview', '_preview', 'image', 'img', 'custom', 'personnal', 'personal', 'mockup'];

    for (const k in props) {
      const key = norm(k);
      const val = props[k];

      if (typeof val === 'string' && urlRe.test(val) && keysPriority.some((sig) => key.includes(sig))) return val;

      if (val && typeof val === 'object') {
        if (typeof val.src === 'string' && urlRe.test(val.src)) return val.src;
        if (typeof val.url === 'string' && urlRe.test(val.url)) return val.url;
      }
    }

    return item.image || '';
  }

  function getProp(props, keys) {
    const wanted = keys.map(norm);
    for (const k in props) {
      if (wanted.includes(norm(k))) return props[k];
    }
    return '';
  }

  function getFromOptionsWithValues(item, nameCandidates) {
    const set = Array.isArray(item.options_with_values) ? item.options_with_values : [];
    const wanted = nameCandidates.map(norm);

    for (const ov of set) {
      if (wanted.includes(norm(ov.name))) return ov.value || '';
    }
    return '';
  }

  function sizeFromItem(item) {
    const props = item.properties || {};
    const p = getProp(props, ['Taille', 'Size']) || getFromOptionsWithValues(item, ['Taille', 'Size']);
    if (p) return String(p).trim();

    if (item.variant_title) {
      const parts = String(item.variant_title).split('/').map((s) => s.trim());
      const hit = parts.find((x) => /\b(\d{1,2}\/\d{1,2}|3xl|xxl|xl|xs|s|m|l|ans|enfant|adulte)\b/i.test(x));
      if (hit) return hit;
    }
    return '';
  }

  function boxFromItem(item) {
    const props = item.properties || {};
    const p =
      getProp(props, ['Boîte', 'Boite', 'Avec boîte', 'Avec boite', 'Sans boîte', 'Sans boite', "Options d'emballage", "Option d'emballage"]) ||
      getFromOptionsWithValues(item, ["options d'emballage", "option d'emballage", 'Boîte', 'Boite']);

    if (p) return String(p).trim();

    if (item.variant_title) {
      const parts = String(item.variant_title).split('/').map((s) => s.trim());
      const hit = parts.find((x) => /(boite|boîte|emballage)/i.test(x));
      if (hit) return hit;
    }
    return '';
  }

  function cleanProps(obj) {
    const out = [];
    const urlRe = /^https?:\/\//i;

    for (const k in obj) {
      if (!Object.prototype.hasOwnProperty.call(obj, k)) continue;

      const key = k || '';
      const val = obj[k];
      const lowKey = norm(key);

      const isTech = lowKey.startsWith('_') || lowKey.endsWith('_crop');
      const isUrl = typeof val === 'string' && urlRe.test(val);
      const isWallpaperMeta =
        lowKey.includes('wallpaper') ||
        lowKey.includes('fond d ecran') ||
        lowKey.includes('fond d’écran') ||
        lowKey.includes('fond-ecran') ||
        lowKey.includes('fond_ecran');

      if (isTech || isUrl || isWallpaperMeta) continue;
      if (val == null || String(val).trim() === '') continue;

      out.push({ key, value: val });
    }

    return out;
  }

  function renderMeta(item) {
    const props = item.properties || {};
    const title = norm(item.product_title || item.title || '');

    if (title.includes('maillot mystere') || title.includes('maillot mystère')) {
      const taille = sizeFromItem(item);
      const boite = boxFromItem(item);
      const exclu = getProp(props, ['Clubs à exclure', 'Club à exclure', 'Clubs a exclure', 'Club a exclure']);

      return [
        `TAILLE: ${taille || '—'}`,
        `OPTIONS D’EMBALLAGE: ${boite || '—'}`,
        exclu ? `CLUBS À EXCLURE: ${exclu}` : ''
      ].filter(Boolean).join('\n');
    }

    const cleaned = cleanProps(props);
    return cleaned.length ? cleaned.map((p) => `${p.key}: ${p.value}`).join(' • ') : '';
  }

  function isEligible(item) {
    const t = norm(item.product_title || item.title || '');
    const pt = norm(item.product_type || '');
    const u = norm(item.url || '');

    return t.includes(CONFIG.eligibleKeyword) || pt.includes(CONFIG.eligibleKeyword) || u.includes(CONFIG.eligibleKeyword);
  }

  function updatePromoProgress(cart) {
    if (!els.progressBar && !els.progressText) return;

    const eligibleQty = (cart.items || []).reduce((n, i) => n + (isEligible(i) ? (i.quantity || 0) : 0), 0);

    if (els.progressText) {
      if (eligibleQty >= CONFIG.promoQty) {
        els.progressText.innerHTML = '<strong>Offre activée : -50% sur la 2ᵉ coque 🎉</strong>';
      } else {
        const need = Math.max(0, CONFIG.promoQty - eligibleQty);
        els.progressText.innerHTML = `Ajoute ${need} coque${need > 1 ? 's' : ''} pour <strong>-50%</strong> sur la 2ᵉ`;
      }
    }

    if (els.progressBar) {
      const pct = eligibleQty >= CONFIG.promoQty ? 100 : Math.min(100, (eligibleQty / CONFIG.promoQty) * 100);
      els.progressBar.style.width = `${pct}%`;
    }
  }

  function renderCart(cart) {
    if (!els.items) return;

    els.items.innerHTML = '';

    const globalWallpaperBanner = renderWallpaperGlobal(cart);
    if (globalWallpaperBanner) {
      els.items.insertAdjacentHTML('beforeend', globalWallpaperBanner);
    }

    (cart.items || []).forEach((item) => {
      const rawImg = getPreviewImage(item);
      const imgUrl = rawImg ? upscaleShopifyImage(rawImg, CONFIG.cartItemImageWidth) : '';
      const shortTitle = cleanTitle(item.product_title || item.title || '');

      let metaHTML = '';
      try {
        metaHTML = (renderMeta(item) || '').replace(/\n/g, '<br>');
      } catch (e) {
        metaHTML = '';
      }

      const wallpaperHTML = renderWallpaperCard(item);

      const card = document.createElement('article');
      card.className = 'cd-item';
      card.dataset.key = item.key;

      card.innerHTML = `
        <figure class="cd-thumb">
          <img src="${esc(imgUrl)}" alt="${esc(shortTitle)}" loading="lazy">
        </figure>

        <div class="cd-body">
          <div class="cd-row">
            <h4 class="cd-title">${esc(shortTitle)}</h4>

            <button class="cd-bin" type="button" aria-label="Supprimer">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M9 3h6l1 2h4v2H4V5h4l1-2zm1 6h2v10h-2V9zm4 0h2v10h-2V9zM7 9h2v10H7V9z"></path>
              </svg>
            </button>
          </div>

          ${metaHTML ? `<div class="cd-itemmeta">${metaHTML}</div>` : ''}
          ${wallpaperHTML}

          <div class="cd-meta">
            <span class="cd-qtytxt">Qté : <strong>${item.quantity || 1}</strong></span>
            <span class="cd-price">${money(item.final_line_price)}</span>
          </div>
        </div>
      `;

      els.items.appendChild(card);

      const bin = card.querySelector('.cd-bin');
      if (bin) {
        bin.addEventListener('click', () => {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: 0 })
          }).then(() => {
            setTimeout(fetchCart, CONFIG.refreshDelay);
          });
        });
      }
    });

    if (els.total) els.total.textContent = money(cart.total_price || 0);
    if (els.ctaTotal) els.ctaTotal.textContent = money(cart.total_price || 0);
    if (els.count) els.count.textContent = cart.item_count || 0;
  }

  let glassProduct = null;

  const cartHasCoque = (cart) => (cart.items || []).some((i) => isEligible(i));
  const cartHasGlass = (cart, glassProductId) => (cart.items || []).find((i) => i.product_id === glassProductId);

  function fetchGlassProduct() {
    if (glassProduct) return Promise.resolve(glassProduct);

    return fetch(`/products/${CONFIG.glassHandle}.js`, { cache: 'no-store' })
      .then((r) => r.json())
      .then((p) => {
        glassProduct = p;
        return p;
      })
      .catch(() => null);
  }

  function renderGlassUpsell(cart) {
    if (!els.glassSection) return;

    if (!cartHasCoque(cart)) {
      els.glassSection.hidden = true;
      return;
    }

    fetchGlassProduct().then((product) => {
      if (!product) {
        els.glassSection.hidden = true;
        return;
      }

      const imgSrc = (product.images && product.images.length) ? product.images[0] : product.featured_image;
      if (els.glassImg && imgSrc) els.glassImg.src = upscaleShopifyImage(imgSrc, CONFIG.glassImageWidth);

      const inCart = cartHasGlass(cart, product.id);
      const isOn = Boolean(inCart);

      if (els.glassSwitch) {
        els.glassSwitch.classList.toggle('is-on', isOn);
        els.glassSwitch.setAttribute('aria-pressed', isOn ? 'true' : 'false');

        els.glassSwitch.onclick = () => {
          if (!inCart) {
            const vid = product.variants && product.variants.length ? product.variants[0].id : null;
            if (!vid) return;

            const fd = new FormData();
            fd.append('id', vid);
            fd.append('quantity', 1);

            fetch('/cart/add.js', { method: 'POST', body: fd }).then(() => {
              setTimeout(() => {
                fetchCart().then(() => open());
              }, CONFIG.refreshDelay);
            });
          } else {
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: inCart.key, quantity: 0 })
            }).then(() => {
              setTimeout(fetchCart, CONFIG.refreshDelay);
            });
          }
        };
      }

      els.glassSection.hidden = false;
    });
  }

  function ensureCoqueUpsellRoot() {
    let root = drawer.querySelector('#cd-coque-upsell');
    if (root) return root;

    root = document.createElement('section');
    root.id = 'cd-coque-upsell';
    root.className = 'cd-coque-upsell';

    const content = drawer.querySelector('.cd-content');
    if (!content) return null;

    if (els.glassSection && els.glassSection.parentNode === content) {
      content.insertBefore(root, els.glassSection);
    } else {
      content.appendChild(root);
    }

    return root;
  }

  async function searchProductsByQueries(queries) {
    const map = new Map();

    for (const q of queries) {
      if (!q) continue;

      const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=${CONFIG.searchLimit}&resources[options][unavailable_products]=hide`;

      try {
        const res = await fetch(url, { cache: 'no-store' });
        const data = await res.json();
        const products = ((((data || {}).resources || {}).results || {}).products || []);

        products.forEach((p) => {
          const handle = norm(p.handle || getHandleFromUrl(p.url || ''));
          if (!handle) return;
          if (!map.has(handle)) map.set(handle, p);
        });
      } catch (e) {}
    }

    return Array.from(map.values());
  }

  function scoreReco(baseItem, product, baseFamilyLabel) {
    const baseHandle = getProductHandle(baseItem);
    const baseType = detectType(baseHandle + ' ' + (baseItem.product_title || baseItem.title || ''));
    const wantedOpposite = getOppositeType(baseType);

    const productHandle = norm(product.handle || getHandleFromUrl(product.url || ''));
    const productType = detectType(productHandle + ' ' + (product.title || ''));

    let score = 0;

    if (familyMatches(product, baseFamilyLabel)) score += 100;
    if (wantedOpposite && productType === wantedOpposite) score += 80;
    if (productType && productType !== baseType) score += 20;
    if (productType === baseType) score -= 15;

    return score;
  }

  function buildUpsellCopy(baseFamilyLabel, firstRecoProduct, baseItem) {
    const prettyFamily = baseFamilyLabel
      .split(' ')
      .filter(Boolean)
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(' ');

    const firstType = prettifyType(
      detectType((firstRecoProduct.handle || getHandleFromUrl(firstRecoProduct.url || '')) + ' ' + (firstRecoProduct.title || ''))
    );

    if (firstType) {
      return {
        eyebrow: `Complète ton pack ${prettyFamily}`,
        title: `Ajoute ${prettyFamily} ${firstType} à -50 %`,
        text: 'Complète ta commande avec les autres coques disponibles de la même collection.'
      };
    }

    return {
      eyebrow: `Complète ton pack ${prettyFamily}`,
      title: `Ajoute une autre coque ${prettyFamily}`,
      text: 'Découvre toutes les autres coques disponibles de la même collection.'
    };
  }

  function getRecoImage(product) {
    if (!product) return '';

    if (typeof product.featured_image === 'string') return upscaleShopifyImage(product.featured_image, CONFIG.pairingImageWidth);
    if (product.featured_image && product.featured_image.url) return upscaleShopifyImage(product.featured_image.url, CONFIG.pairingImageWidth);
    if (typeof product.image === 'string') return upscaleShopifyImage(product.image, CONFIG.pairingImageWidth);
    if (product.image && product.image.url) return upscaleShopifyImage(product.image.url, CONFIG.pairingImageWidth);
    if (product.images && product.images.length) return upscaleShopifyImage(product.images[0], CONFIG.pairingImageWidth);

    return '';
  }

  function buildRecoUrl(product, cartItem) {
    const query = buildPrefillParams(cartItem);
    const baseUrl = product.url || `/products/${product.handle || getHandleFromUrl(product.url || '')}`;
    return query ? `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}${query}` : baseUrl;
  }

  function buildRecoDisplayTitle(product) {
    const cleaned = cleanTitle(product.title || '');
    return cleaned || 'Coque assortie';
  }

  function buildRecoButtonLabel(product) {
    const cleaned = cleanTitle(product.title || '');
    return cleaned ? `Personnaliser ${cleaned}` : 'Personnaliser cette coque';
  }

  async function renderFamilyUpsells(cart) {
    const root = ensureCoqueUpsellRoot();
    if (!root) return;

    const eligibleItems = (cart.items || []).filter((i) => isEligible(i));

    if (!eligibleItems.length) {
      root.hidden = true;
      root.innerHTML = '';
      return;
    }

    const baseItem = eligibleItems[0];
    const baseFamilyLabel = getFamilyLabel(baseItem);
    const inCartHandles = new Set((cart.items || []).map((i) => getProductHandle(i)).filter(Boolean));

    if (!baseFamilyLabel) {
      root.hidden = true;
      root.innerHTML = '';
      return;
    }

    const queries = buildSearchQueries(baseItem);
    const allProducts = await searchProductsByQueries(queries);

    const familyProducts = allProducts
      .filter((p) => {
        const handle = norm(p.handle || getHandleFromUrl(p.url || ''));
        if (!handle) return false;
        if (inCartHandles.has(handle)) return false;
        return familyMatches(p, baseFamilyLabel);
      })
      .sort((a, b) => scoreReco(baseItem, b, baseFamilyLabel) - scoreReco(baseItem, a, baseFamilyLabel))
      .slice(0, CONFIG.maxReco);

    if (!familyProducts.length) {
      root.hidden = true;
      root.innerHTML = '';
      return;
    }

    const copy = buildUpsellCopy(baseFamilyLabel, familyProducts[0], baseItem);

    root.hidden = false;
    root.innerHTML = `
      <div class="cd-coque-upsell__box">
        <div class="cd-coque-upsell__head">
          <div class="cd-coque-upsell__eyebrow">${esc(copy.eyebrow)}</div>
          <h3>${esc(copy.title)}</h3>
          <p>${esc(copy.text)}</p>
        </div>

        <div class="cd-coque-upsell__list">
          ${familyProducts.map((p) => {
            const img = getRecoImage(p);
            const price = typeof p.price === 'number' ? money(p.price) : '';
            const compare = (typeof p.compare_at_price === 'number' && p.compare_at_price > p.price)
              ? money(p.compare_at_price)
              : '';
            const recoUrl = buildRecoUrl(p, baseItem);
            const displayTitle = buildRecoDisplayTitle(p);
            const btnLabel = buildRecoButtonLabel(p);

            return `
              <article class="cd-coque-reco">
                <a class="cd-coque-reco__img" href="${esc(recoUrl)}">
                  <img src="${esc(img)}" alt="${esc(displayTitle)}" loading="lazy">
                </a>

                <div class="cd-coque-reco__body">
                  <a class="cd-coque-reco__title" href="${esc(recoUrl)}">${esc(displayTitle)}</a>

                  <div class="cd-coque-reco__price">
                    ${compare ? `<span class="cd-coque-reco__compare">${compare}</span>` : ''}
                    <span class="cd-coque-reco__current">${price}</span>
                  </div>

                  <a class="cd-coque-reco__btn" href="${esc(recoUrl)}">
                    ${esc(btnLabel)}
                  </a>
                </div>
              </article>
            `;
          }).join('')}
        </div>
      </div>
    `;
  }

  function fetchCart() {
    return fetch('/cart.js', { cache: 'no-store' })
      .then((r) => r.json())
      .then((cart) => {
        updateCartBubbleCount(cart);
        renderCart(cart);
        updatePromoProgress(cart);
        renderGlassUpsell(cart);
        return renderFamilyUpsells(cart).then(() => cart);
      })
      .catch(() => null);
  }

  function scheduleDrawerRefresh(openDrawer = false) {
    setTimeout(() => {
      fetchCart().then(() => {
        if (openDrawer) open();
      });
    }, CONFIG.refreshDelay);
  }

  function urlMatchesCartMutation(url) {
    const u = String(url || '');
    return u.includes('/cart/add') || u.includes('/cart/change') || u.includes('/cart/update') || u.includes('/cart/clear');
  }

  if (!window.__NAO_FETCH_HOOKED_CLUB_SCALABLE_FINAL__) {
    window.__NAO_FETCH_HOOKED_CLUB_SCALABLE_FINAL__ = true;
    const _fetch = window.fetch.bind(window);

    window.fetch = async (...args) => {
      const res = await _fetch(...args);

      try {
        const url = (args && args[0]) ? (typeof args[0] === 'string' ? args[0] : args[0].url) : '';

        if (urlMatchesCartMutation(url)) {
          if (String(url).includes('/cart/add')) {
            setTimeout(() => {
              fetchCart().then(() => open());
            }, CONFIG.addOpenDelay);
          } else {
            scheduleDrawerRefresh(false);
          }
        }
      } catch (e) {}

      return res;
    };
  }

  if (!window.__NAO_XHR_HOOKED_CLUB_SCALABLE_FINAL__) {
    window.__NAO_XHR_HOOKED_CLUB_SCALABLE_FINAL__ = true;

    const _open = XMLHttpRequest.prototype.open;
    const _send = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function(method, url, ...rest) {
      this.__nao_url = url;
      return _open.call(this, method, url, ...rest);
    };

    XMLHttpRequest.prototype.send = function(body) {
      this.addEventListener('load', () => {
        try {
          const u = this.__nao_url || this.responseURL;
          if (urlMatchesCartMutation(u)) {
            if (String(u).includes('/cart/add')) {
              setTimeout(() => {
                fetchCart().then(() => open());
              }, CONFIG.addOpenDelay);
            } else {
              scheduleDrawerRefresh(false);
            }
          }
        } catch (e) {}
      });

      return _send.call(this, body);
    };
  }

  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (!form) return;

    const action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;

    setTimeout(() => {
      fetchCart().then(() => open());
    }, CONFIG.fallbackSubmitDelay);
  }, true);

  document.addEventListener('cart:refresh', () => {
    fetchCart();
  });

  window.NAO_CART_DRAWER = {
    open,
    close,
    refresh: fetchCart
  };

  document.addEventListener('cart:open', open);

  fetchCart();
})();